import React from 'react'

function SignatureIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={22}
      fill="none"
      {...props}
    >
      <path
        stroke={props?.stroke || '#2E8AB8'}
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M2.52 19.479h16.96M4.354 15.813c3.82-4.43 10.45-13.292 6.417-13.292-5.042 0-7.334 10.542-3.667 12.375 3.667 1.834 4.803-4.44 5.042-2.291.285 2.57 3.444 2.77 5.5 2.291"
      />
    </svg>
  )
}
export default SignatureIcon
